import { VideoResourceField } from '@src/services/VideoResourcesProvider';
import type WaveformData from 'waveform-data';

export enum VideoResolution {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  HD = 'hd',
  Original = 'original',
}

export enum AspectRatio {
  AR_16_9 = '16:9',
  AR_1_1 = '1:1',
  AR_9_16 = '9:16',
}

export enum VideoDimensionsWidth {
  AR_16_9 = 1280,
  AR_1_1 = 720,
  AR_9_16 = 405,
}

export enum VideoDimensionsHeight {
  AR_16_9 = 720,
  AR_1_1 = 720,
  AR_9_16 = 720,
}

export enum TranscriptionStatus {
  Idle = 'idle',
  None = 'none',
  Loading = 'loading',
  Failed = 'failed',
  Loaded = 'loaded',
  GenerationFailed = 'generation_failed',
}

export enum SubtitleStatus {
  None = 'none',
  Loading = 'loading',
  Loaded = 'loaded',
  Failed = 'failed',
}

export enum VideoStatus {
  None = 'none',
  Rendering = 'rendering',
  Rendered = 'rendered',
  Editing = 'editing',
  Error = 'error',
}

export type VideoResource = {
  url: string;
};

export type VideoResourceMetadata = {
  fileKey: string;
  fileName: string;
  md5Hash: string;
};

export type VideoResources = {
  videoSourceSnapshot?: VideoResource;
  transcriptionSnapshot?: VideoResource;
  karaokeData?: VideoResource;
};

export type VideoResourcesMetadata = Partial<
  Record<VideoResourceField, VideoResourceMetadata>
>;

export type VideoSource = Record<string, any>;

export type WaveformState =
  | { status: 'loading'; data: null }
  | { status: 'ready'; data: WaveformData }
  | { status: 'error'; data: null };
